(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-header"]) return;
  try {
    
(() => {
  let saleTimer;
  const syncSale = () => {
    clearTimeout(saleTimer);
    const bar = document.querySelector('.aw-sale-bar[data-aw-sale-end]');
    if (!bar) return;
    const remaining = Number(bar.dataset.awSaleEnd) - Date.now();
    if (remaining <= 0) {
      bar.remove();
      document.querySelectorAll('.aw-header--below-sale').forEach(header => header.classList.remove('aw-header--below-sale'));
    } else {
      saleTimer = setTimeout(syncSale, Math.min(remaining + 10, 2147483647));
    }
  };
  window.addEventListener('pageshow', syncSale);
  document.addEventListener('visibilitychange', syncSale);
  const init = () => {
    document.querySelectorAll('.aw-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const close = () => { menu.open = false; menu.querySelector('summary').focus(); };
      menu.querySelector('.aw-menu__close').addEventListener('click', close);
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });
  };
  init(); syncSale(); document.addEventListener('shopify:section:load', () => { init(); syncSale(); });
})();

  } catch(e) { console.error(e); }
})();
})();
